import type { WorldSlug } from '@/lib/worlds';

/**
 * Per-world hero / cover SVG assets shipped under `pwa/public/covers/`.
 *
 * Two consumers as of the Batch 8 Library bug-fix commit (2026-04-26):
 *   - `StoryCard` density='library' (40×40 cover tile in the Library
 *     row layout) → `getLibraryCover(slug)`
 *   - `WeltCard` hero (full-bleed image in the Start-Page "Welten
 *     entdecken" row) → `getHeroCover(slug)`
 *
 * Both helpers fall back to `/covers/cover-default.svg` for unknown
 * slugs — keeps the render path safe across the PWA-startup race
 * window (LibraryRoute resolves `worldSlugMap` asynchronously after
 * mount, so a brief render with the legacy substring-fallback slug is
 * possible).
 *
 * Closes PWA/Offen #26 (WeltCard hero PNGs) — Sönke delivered the
 * SVG variants on 2026-04-26.
 */

const FALLBACK_COVER = '/covers/cover-default.svg';

const LIBRARY_COVER_BY_SLUG: Record<WorldSlug, string> = {
  aa: '/covers/Library_AA.svg',
  kp: '/covers/Library_KP.svg',
  sb: '/covers/Library_SB.svg',
};

const HERO_COVER_BY_SLUG: Record<WorldSlug, string> = {
  aa: '/covers/card-world-img_AA.svg',
  kp: '/covers/card-world-img_KP.svg',
  sb: '/covers/card-world-img_SB.svg',
};

export function getLibraryCover(slug: string | null | undefined): string {
  if (!slug) return FALLBACK_COVER;
  return LIBRARY_COVER_BY_SLUG[slug as WorldSlug] ?? FALLBACK_COVER;
}

export function getHeroCover(slug: string | null | undefined): string {
  if (!slug) return FALLBACK_COVER;
  return HERO_COVER_BY_SLUG[slug as WorldSlug] ?? FALLBACK_COVER;
}
